import { memo } from 'react';

import Box from '@zenbusiness/zui/Box';
import Heading from '@zenbusiness/zui/Heading';
import Stack from '@zenbusiness/zui/Stack';

import { FocusGrid, ContainerGrid } from '#client/components/Grid';
import useBreakpoints from '#client/hooks/useBreakpoints';
import useModalDisplayTracker from '#client/hooks/useModalDisplayTracker';

import { ImageStyled, ImageWrapper, ContentWrapper } from './components/ApplicationIntro.styles';
import Stepper from './components/Stepper';

import { INTRO_STEPS } from './constants/steps';

const Image = () => (
  <ImageWrapper>
    <ImageStyled
      alt=""
      src="/s2/vector/pbf-banking.svg"
    />
  </ImageWrapper>
);

const ApplicationIntro = () => {
  const {
    sizes: { isMobile }
  } = useBreakpoints();

  /**
   * Tracking Details: Tracking details to be added for Banking application page views.
   * Question: How many customers view this version banking application modal?
   */
  useModalDisplayTracker({
    elementName: 'banking_pre_mfa_black_card_version',
    elementText: 'banking_pre_mfa_black_card_version',
    appPageName: 'banking_pre_mfa_black_card_version'
  });

  return (
    <ContainerGrid
      paddingBottom="80px"
      paddingTop={{ xs: '24px', md: '34px' }}
    >
      <FocusGrid>
        {!isMobile && <Image />}
        <ContentWrapper>
          <Box mb="16px">
            <Heading
              family="secondary"
              size="3xl"
              weight="bold"
            >
              Let&apos;s get you ready to bank, so your finances stay separate from the start
            </Heading>
            {isMobile && <Image />}
          </Box>
          <Box mb="16px">
            <Stack mt="32px">
              <Stepper steps={INTRO_STEPS} />
            </Stack>
          </Box>
        </ContentWrapper>
      </FocusGrid>
    </ContainerGrid>
  );
};

export default memo(ApplicationIntro);
